import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const Accordion = ({ 
  isActive, 
  title, 
  children, 
  icon: Icon, 
  iconColor = 'blue', 
  bgColor = 'blue',
  darkMode,
  onToggle,
  preventToggle = false
}) => {
  // İkon renklerini belirleme
  const iconColors = {
    blue: 'text-blue-500',
    purple: 'text-purple-500',
    green: 'text-green-500',
    yellow: 'text-yellow-500',
    red: 'text-red-500',
    cyan: 'text-cyan-500'
  };

  // Arka plan renklerini belirleme
  const bgColors = {
    blue: darkMode ? 'bg-blue-900/40' : 'bg-blue-100',
    purple: darkMode ? 'bg-purple-900/40' : 'bg-purple-100',
    green: darkMode ? 'bg-green-900/40' : 'bg-green-100',
    yellow: darkMode ? 'bg-yellow-900/40' : 'bg-yellow-100',
    red: darkMode ? 'bg-red-900/40' : 'bg-red-100',
    cyan: darkMode ? 'bg-cyan-900/40' : 'bg-cyan-100'
  };
  
  const handleToggle = () => {
    if (!preventToggle && onToggle) {
      onToggle();
    }
  };

  return (
    <div className={`rounded-xl ${darkMode ? 'bg-gray-800' : 'bg-gray-50'} shadow-lg overflow-hidden`}>
      <div 
        className={`${
          isActive ? `${bgColors[bgColor]} shadow-inner` : ''
        } p-4 flex justify-between items-center cursor-pointer transition-all`}
        onClick={handleToggle}
      >
        <div className="flex items-center">
          {Icon && <Icon className={`mr-2 ${iconColors[iconColor]}`} size={20} />}
          <h3 className={`font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>
            {title}
          </h3>
        </div>
        {!preventToggle && (
          isActive 
            ? <ChevronUp className={`${darkMode ? 'text-gray-400' : 'text-gray-600'}`} size={20} /> 
            : <ChevronDown className={`${darkMode ? 'text-gray-400' : 'text-gray-600'}`} size={20} />
        )}
      </div>
      
      <div className={`transition-all duration-300 ${
        isActive 
          ? 'max-h-[1000px] opacity-100' 
          : 'max-h-0 opacity-0 pointer-events-none'
      } overflow-hidden`}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;